/**
 * Calculs purs de la courbe de température d'une PAC, testés seuls
 * (`courbeTemperature.test.js`).
 */

/**
 * L'échelle verticale : de la plus basse à la plus haute des deux séries, avec un
 * degré de marge, et au moins 2 °C d'amplitude. Une consigne fixe et une pièce stable
 * donneraient sinon une échelle nulle (division par zéro) ou une courbe qui amplifie
 * 0,1 °C de bruit en montagnes russes.
 */
export function echelleTemperatures(points) {
  const valeurs = [];
  for (const p of points || []) {
    for (const cle of ['temperature_mesuree', 'temperature_consigne']) {
      const v = Number(p?.[cle]);
      if (p?.[cle] != null && Number.isFinite(v)) valeurs.push(v);
    }
  }
  if (!valeurs.length) return { min: 0, max: 1 };
  let min = Math.floor(Math.min(...valeurs) - 1);
  let max = Math.ceil(Math.max(...valeurs) + 1);
  if (max - min < 2) { min -= 1; max += 1; }
  return { min, max };
}

/** L'heure locale d'un horodatage ISO, « 14:58 ». Vide si illisible. */
export function heureLocale(iso) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
}
